import * as React from "react";
import { Link } from "react-router-dom";
import { Sticky } from "react-sticky";
import cx from "classnames";

import { Box } from "../../../components";
import "./Nav.css";

const logo: string = require("../../../images/logo.png");

export interface WizardNavProps {
  children?: JSX.Element[];
}

interface NavState {
  collapsed: boolean;
}

const getNavBarClass = ({ collapsed }: NavState) =>
  cx("navbar-collapse", "navbar-collapse__wizard", "collapse", {
    in: !collapsed,
  });

class WizardNav extends React.Component<WizardNavProps, NavState> {
  state: NavState = {
    collapsed: true,
  };
  toggleBtn: Element;

  constructor(props) {
    super(props);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
  }

  public componentDidMount() {
    document.addEventListener("click", this.handleDocumentClick, false);
  }

  public componentWillUnmount() {
    document.removeEventListener("click", this.handleDocumentClick, false);
  }

  private handleDocumentClick = event => {
    if (!this.toggleBtn.contains(event.target)) {
      this.setState(state => ({
        ...state,
        collapsed: true,
      }));
    }
  };

  private toggleNavBarCollapse = () => {
    this.setState(state => ({
      ...state,
      collapsed: !this.state.collapsed,
    }));
  };

  private assignRef = element => {
    this.toggleBtn = element;
  };

  render() {
    return (
      <Sticky disableCompensation topOffset={-10}>
        {({ style }) => (
          <nav
            className="navbar navbar-default navbar-custom wizard-nav"
            style={style}
          >
            <Box fullWidth hasShadow>
              <div className="navbar-header">
                <button
                  type="button"
                  className="navbar-toggle collapsed"
                  ref={this.assignRef}
                  onClick={this.toggleNavBarCollapse}
                >
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                </button>
                <Link to="/" className="navbar-brand">
                  <img className="img-responsive" src={logo} />
                </Link>
              </div>
              <div className={getNavBarClass(this.state)}>
                <div className="wizard-nav-container">
                  <ul className="nav navbar-nav wizard-nav-steps">
                    {this.props.children}
                  </ul>
                  <ul className="nav navbar-nav wizard-nav-help navbar-right">
                    <li className="help-btn">
                      <Link
                        target="_blank"
                        to="/pages/qa"
                        className="help-btn__btn"
                      >
                        Trợ giúp
                      </Link>
                      <div className="help-btn__icon">?</div>
                    </li>
                  </ul>
                </div>
              </div>
            </Box>
          </nav>
        )}
      </Sticky>
    );
  }
}

export default WizardNav;



// WEBPACK FOOTER //
// ./src/routes/Wizard/components/Nav.tsx